export default "__VITE_ASSET__363c028f__"